import {
  createSetting,
  VALUE_TYPE_PERCENTAGE,
  VALUE_TYPE_MONEY,
} from './setting';

export default {
  alimentacaoRefeicao: createSetting(
    'Alimentação / Refeição (R$)',
    VALUE_TYPE_MONEY
  ),
  assistenciaMedica: createSetting('Assitencia Médica (R$)', VALUE_TYPE_MONEY),
  odontologico: createSetting('Odontológico (R$)', VALUE_TYPE_MONEY),
  outrosCustos: createSetting('Outros Custos (R$)', VALUE_TYPE_MONEY),
  percentualGps: createSetting('INSS / GPS (%)', VALUE_TYPE_PERCENTAGE),
};
